module.exports = require("@mui/icons-material/DoNotDisturb");